import { Component } from '@angular/core';
import { IconSize } from '@predictiveindex/tapestry';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';

export interface IHeaderWithIconParams {
    iconSize: IconSize;
    name: string;
}

@Component({
    selector: 'header-with-icon',
    templateUrl: './header-with-icon.component.html',
    styleUrls: ['./header-with-icon.component.less'],
    standalone: false
})
export class HeaderWithIconComponent implements IHeaderAngularComp {
    IconSize = IconSize;

    public params!: any;

    agInit(params: IHeaderParams & IHeaderWithIconParams): void {
        this.params = params;
    }

    refresh(_params: IHeaderParams & IHeaderWithIconParams): boolean {
        return false;
    }
}
